export enum AGENT_TYPE {
  MGA_PRINCIPAL = 'MGA_PRINCIPAL',
  MGA_ADMIN = 'MGA_ADMIN',
  AGENCY_PRINCIPAL = 'AGENCY_PRINCIPAL',
  AGENCY_ADMIN = 'AGENCY_ADMIN',
  GENERAL_AGENT = 'GENERAL_AGENT',
  CARRIER_REP = 'CARRIER_REP',
}

export const agencyTypeMap = new Map([
  [AGENT_TYPE.MGA_PRINCIPAL, 'MGA Principal'],
  [AGENT_TYPE.MGA_ADMIN, 'MGA Admin'],
  [AGENT_TYPE.AGENCY_PRINCIPAL, 'Agency Principal'],
  [AGENT_TYPE.AGENCY_ADMIN, 'Agency Admin'],
  [AGENT_TYPE.GENERAL_AGENT, 'General Agent'],
  [AGENT_TYPE.CARRIER_REP, 'Carrier Rep'],
]);

export const AGENT_TYPE_LOOKUP = [
  { value: AGENT_TYPE.MGA_PRINCIPAL, description: 'MGA Principal' },
  { value: AGENT_TYPE.MGA_ADMIN, description: 'MGA Admin' },
  { value: AGENT_TYPE.AGENCY_PRINCIPAL, description: 'Agency Principal' },
  { value: AGENT_TYPE.AGENCY_ADMIN, description: 'Agency Admin' },
  { value: AGENT_TYPE.GENERAL_AGENT, description: 'General Agent' },
  { value: AGENT_TYPE.CARRIER_REP, description: 'Carrier Rep' },
];
